module.exports = __webpack_public_path__ + "img/multiply_white.33f2fdc9.png";